import React from 'react'
import "./Assets/styles.css"
import { IconButton } from '@mui/material'
import { ArrowLeft2, ArrowRight2, } from 'iconsax-react'

const Paginado = ({ nextHandler, prevHandler, currentPage, mostrarNext, totalItems }) => {

  return (
    <div className='paginado-services'>
      <IconButton onClick={prevHandler}>
        <ArrowLeft2 size="40" color="#004274"></ArrowLeft2>
      </IconButton>
      {currentPage == 0 ?
        ""
        :
        <span className='before-pag'></span>
      }

      <span className='current-pag'>{currentPage + 1}</span>
      {
        (currentPage + 1)  * 5 > totalItems ?
          ''
          :
          <span className='after-pag'></span>
      }








      <IconButton onClick={nextHandler}>
        <ArrowRight2 size="40" color="#004274"></ArrowRight2>
      </IconButton>
    </div>
  )
}

export default Paginado